import { Component, ReactNode } from 'react'
import * as styles from 'components/features/pfm/Popup/Popup.styl'
import { OverlayContainer } from 'components/features/pfm/Overlay/OverlayContainer'
import { OverlayMobile } from 'components/features/pfm/Overlay/OverlayMobile'
import CloseButton from 'components/atoms/buttons/CloseButton'
import withMobile, { WithMobileProps } from 'hocs/withMobile/withMobile'
import PopupCloseButton from 'components/features/pfm/Popup/PopupCloseButton'
import { PopupTitle } from 'components/atoms/Text'
import { QA_MARKER_OVERLAY_CLOSE_BUTTON } from 'constants/component'

export type PopupOwnProps = {
  title?: ReactNode
  withBottomCloseButton?: boolean
  undismissible?: boolean

  onCloseButtonClick: () => void
}

type PopupProps = WithMobileProps & PopupOwnProps

class Popup extends Component<PopupProps> {
  render () {
    const {
      isMobile,
      children,
      withBottomCloseButton,
      onCloseButtonClick,
      undismissible = false,
    } = this.props

    const OverlayComponent = isMobile
      ? OverlayMobile
      : OverlayContainer

    return (
      <OverlayComponent onClose={ onCloseButtonClick }>
        <div className={ styles.popup }>
          { !isMobile && !undismissible && (
            <div className={ styles.closeButtonWrapper }>
              <CloseButton onClick={ onCloseButtonClick } qaMarker={ QA_MARKER_OVERLAY_CLOSE_BUTTON } />
            </div>
          )}
          { this.renderTitle() }
          <div className={ styles.content }>
            { children }
            {
              withBottomCloseButton && (
                <PopupCloseButton onClick={ onCloseButtonClick } />
              )
            }
          </div>
        </div>
      </OverlayComponent>
    )
  }

  renderTitle () {
    const { title } = this.props

    if (!title) {
      return null
    }

    return (
      <div className={ styles.titleWrapper }>
        <PopupTitle>
          { title }
        </PopupTitle>
      </div>
    )
  }
}

export default withMobile(Popup)
